module.exports = __webpack_public_path__ + "selwebee_spt_brokenwindow-ENGLISH-1c0ea81948539bd2bed7decec728bb8d.png";